<template>
    <div>
        <card class="mb-5">
            <template slot="body">
                <div class="row">
                    <shop-profile-section />
                    <div class="col-lg-6 col-sm-12" style="padding: 0px 30px;">
                        <h6 class="heading-small text-muted" style="padding: 0px 15px;">Shop Schedule</h6>
                        <operation-item v-for="(schedule, key) in schedules" :key="key" :schedule="schedule" />
                    </div>
                    <div class="col-lg-6 col-sm-12 mt-lg--8">
                        <h6 class="heading-small text-muted">Appointment Schedule</h6>
                        <div class="row pb-3">
                            <div class="col-lg-10 col-sm-12">
                                <form-date-picker time
                                    format="MMMM DD, YYYY hh:mm a"
                                    label="Appointment Date and Time"
                                    placeholder="datetime"
                                    v-model="form.datetime"
                                    :min-date="minDate"
                                    ref="datetime"
                                ></form-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <button v-if="!isRequesting" class="btn btn-warning float-right" @click="save">
                            Next <i class="fas fa-angle-right ml-2"></i>
                        </button>
                        <button v-else class="btn btn-warning float-right disabled" disabled>
                            Next <i class="fas fa-angle-right ml-2"></i>
                        </button>
                    </div>
                </div>
            </template>
        </card>
    </div>
</template>
<script>
import '@styles/table.css';
import moment from "moment";
import { route, post } from '@utils/network';
import mixins from "@utils/mixins";

import ShopProfileSection from "./ShopProfileSection";
import OperationItem from "./OperationItem";

export default {
    name: "BookingScheduleSection",

    components: { ShopProfileSection, OperationItem },

    computed: {
        initialData() {
            return this.$store.getters.shopSearchParams;
        },
        minDate() {
            return moment().add(2, "hours").format("MMMM DD, YYYY hh:mm A");
        },
        timezoneOffset() {
            return new Date().getTimezoneOffset() / 60;
        },
        shop() {
            return this.$store.getters.shop;
        },
        schedules() {
            return this.$store.getters.shop.operations ||  [];
        },
    },

    data: () => ({
        isRequesting: false,
        form: {
            booking_type: "in-shop",
            shop_id: null,
            datetime: moment().add(2, "hours").format("MMMM DD, YYYY hh:mm A"),
        },
    }),
    
    methods: {
        updatedSelectedAddress(address) {
            this.address = address,
            this.form.longitude = address.longitude;
            this.form.latitude = address.latitude;
            this.$nextTick(() => this.$refs.map.resetMarkers());
        },
        save() {
            this.isRequesting = true;
            this.form.shop_id = this.shop.id;
            const datetime = moment(this.form.datetime).add(this.timezoneOffset, "hour").format("MMMM DD, YYYY hh:mm a");
            post(route("shops/search"), { data: {...this.form, datetime }})
                .then(response => this.mapScheduleData(response))
                .catch(error => this.handleErrors(error))
                .finally(() => this.isRequesting = false);
        },

        mapScheduleData(response) {
            if (!response.data.result.shop) {
                return this.promptErrors("Please select a different date/time for your appointment.", "Schedule not available");
            }
            const datetime = moment(this.form.datetime).add(this.timezoneOffset, "hour").format("MMMM DD, YYYY hh:mm a");
            this.$store.dispatch("setScheduleParams", { ...this.form, datetime });
            this.$emit("next");
        },

        handleErrors(error) {
            console.log(error);
            this.promptFormErrors(this.$refs, error);
        },
        initializeData() {
            const datetime = this.initialData.datetime
                ? moment(this.initialData.datetime).add(this.timezoneOffset, "hour")
                : moment().add(2, "hour");
            this.form.datetime = datetime.format("MMMM DD, YYYY hh:mm a");
        },
    },

    mixins: [mixins],

    mounted() {
        this.initializeData();
    },

}
</script>